import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=28410896"
import script from "../../services/layout/main-layout.js?vue&type=script&lang=js&external"
export * from "../../services/layout/main-layout.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports